import { html } from 'lit';

export function renderNotFoundPage(path: string): unknown {
  return html`
    <div class="placeholder-page">
      <div class="placeholder-icon">?</div>
      <h1 class="placeholder-title">Territoire inexplore</h1>
      <p class="placeholder-text">
        Le chemin <code class="placeholder-code">${path}</code> ne mene nulle part.
      </p>
      <a href="#/" class="placeholder-link">Retour au camp</a>
    </div>
  `;
}

export function renderSoonPage(titre: string, milestone: string): unknown {
  return html`
    <div class="placeholder-page">
      <div class="placeholder-icon">...</div>
      <h1 class="placeholder-title">${titre}</h1>
      <p class="placeholder-text">
        Ce chapitre est en cours d'ecriture. Disponible au milestone <strong>${milestone}</strong>.
      </p>
    </div>
  `;
}
